// extracted by mini-css-extract-plugin
export default {"zoomInIcon":"ButtonCropZoomIn_zoomInIcon__CvnsJ"};